import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, data }) => {
  switch (type) {
    case types.GET_UN_NUMBER_LIST_FAILURE:
      return {
        title: t('message.title.error.get.un.number.list'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
